import React, { useReducer } from "react";
import Formsy from "formsy-react";
import {
  Button,
  Grid,
  Container,
  Segment,
  Form,
  Input,
  Message,
} from "semantic-ui-react";
import "./RadiusCheckContainer.less";
import { getRequestRadiusDetails } from "../../services/Manager";
import GoogleMapReact from "google-map-react";
import Config from "Config";
import Marker from "../../components/GMaps/Marker";
import mapUtilityMethods from "utils/mapUtilityMethods";
import DisplayDistanceNew from "components/RequestPostProcessing/DisplayDistanceNew/DisplayDistanceNew";
import DisplayHomeAddress from "components/RequestPostProcessing/DisplayHomeAddress/DisplayHomeAddress";
import stateReducer from "./stateReducer";

const initialStates = {
  requestID: "",
  error: "",
  mapCenter: { lat: 39.8097343, lng: -98.5556199 },
  USCenter: { lat: 39.8097343, lng: -98.5556199 },
  sellerDetail: {
    lat: 0,
    lon: 0,
    sellerID: 0,
    serviceRadius: 0,
    sellerName: "",
  },
  sbrDetail: {
    lat: 0,
    lon: 0,
    postProcessing: undefined,
    quickInfo: "",
  },
};

const RadiusCheckContainer = () => {
  const [state, dispatch] = useReducer(stateReducer, initialStates);

  const handleRequestIDChange = (value) => {
    let requestID = value;
    dispatch({
      type: "setRequestID",
      requestID: requestID,
    });
  };

  const submit = async () => {
    let errorMessage = "";
    let sellerDetail = {};
    let sbrDetail = {};
    let mapCenter = {};

    dispatch({
      type: "setRequestDetail",
      sellerDetail: sellerDetail,
      sbrDetail: sbrDetail,
      mapCenter: mapCenter,
    });

    if (state.requestID && state.requestID > 0) {
      let res = await getRequestRadiusDetails(state.requestID);
      if (res.resStatus == 200) {
        sellerDetail = {
          lat: res.data.sellerLat,
          lon: res.data.sellerLon,
          sellerID: res.data.sellerID,
          serviceRadius: res.data.serviceRadius,
          sellerName: res.data.sellerName,
        };
        sbrDetail = {
          lat: res.data.sbrLat,
          lon: res.data.sbrLon,
          postProcessing: res.data.postProcessing,
          quickInfo: res.data.quickInfo,
        };
        mapCenter = { lat: +res.data.sellerLat, lng: +res.data.sellerLon };
      } else {
        errorMessage = res.message;
      }
    } else {
      errorMessage = "Invalid Request ID";
    }

    dispatch({
      type: "setRequestDetail",
      sellerDetail: sellerDetail,
      sbrDetail: sbrDetail,
      mapCenter: mapCenter,
    });
    handleError(errorMessage);
    setTimeout(() => {
      handleError("");
    }, 2000);
  };

  const handleError = (errorMessage) => {
    dispatch({
      type: "setError",
      error: errorMessage,
    });
  };

  const apiIsLoaded = (map, maps) => {
    try {
      let circle;
      if (google && state.sellerDetail) {
        circle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.3,
          map,
          center: {
            lat: Number(state.sellerDetail.lat),
            lng: Number(state.sellerDetail.lon),
          },
          radius: mapUtilityMethods.convertMilesIntoMeters(
            state.sellerDetail.serviceRadius
              ? state.sellerDetail.serviceRadius
              : 0
          ),
        });
      }
    } catch (e) {
      console.log("Error in apiIsLoaded().");
      console.log(e);
    }
  };

  const MyMarker = (props) => {
    return (
      <>
        <div className="my-pin"></div>
      </>
    );
  };

  const StartEndMarker = (props) => {
    return (
      <>
        <div>
          {props.start ? (
            <div className="start-pin">A</div>
          ) : (
            <div className="end-pin">B</div>
          )}
        </div>
      </>
    );
  };

  const havePostProcessing = () => {
    if (
      state.sbrDetail &&
      state.sbrDetail.postProcessing &&
      Object.keys(state.sbrDetail.postProcessing).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Container fluid className={"radius-check-container"}>
      <div className="main-page-panel">
        <div className="content-panel">
          <div className="mobile-header mobile-header-new">
            <div className="main-heading main-heading-new">Radius Check</div>
          </div>
        </div>
      </div>
      <Segment>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Formsy
                onValidSubmit={() => {
                  submit();
                }}
              >
                <Form.Field inline>
                  <label className="request-id-label">Request ID </label>
                  <Input
                    className="request-id-input"
                    value={state.requestID}
                    onChange={(e, data) => handleRequestIDChange(data.value)}
                    required
                    name="requestID"
                    placeholder="Enter request ID"
                    type="number"
                  />
                  <Button primary type="submit">
                    Search
                  </Button>
                </Form.Field>
              </Formsy>
            </Grid.Column>
          </Grid.Row>
          {state.error ? (
            <Grid.Row>
              <Grid.Column width={16}>
                <Message negative>
                  <p>{state.error}</p>
                </Message>{" "}
              </Grid.Column>
            </Grid.Row>
          ) : (
            ""
          )}
        </Grid>
      </Segment>
      <Segment>
        <Grid>
          <Grid.Row>
            {state.sellerDetail && state.sellerDetail.sellerID ? (
              <>
                <Grid.Column width={10}>
                  <div className="" style={{ height: "500px" }}>
                    <GoogleMapReact
                      key={"map-key-" + state.sellerDetail.sellerID}
                      bootstrapURLKeys={{
                        key: Config.maps.key,
                        language: "en",
                        region: "us",
                      }}
                      defaultZoom={10}
                      zoom={10}
                      center={state.mapCenter}
                      options={{
                        fullscreenControl: false,
                      }}
                      defaultCenter={state.USCenter}
                      onGoogleApiLoaded={({ map, maps }) =>
                        apiIsLoaded(map, maps)
                      }
                    >
                      <Marker
                        lat={state.sellerDetail.lat}
                        lng={state.sellerDetail.lon}
                        title={state.sellerDetail.sellerName}
                        phone={state.sellerDetail.cellPhone}
                        sellerid={state.sellerDetail.sellerID}
                      />

                      <MyMarker
                        lat={state.sbrDetail.lat}
                        lng={state.sbrDetail.lon}
                      />
                      {state.sbrDetail?.postProcessing?.distance
                        ?.sourceAddressLatLng &&
                        state.sbrDetail?.postProcessing?.distance
                          ?.destinationAddressLatLng && (
                          <StartEndMarker
                            start
                            lat={
                              state.sbrDetail?.postProcessing?.distance
                                ?.sourceAddressLatLng.lat
                            }
                            lng={
                              state.sbrDetail?.postProcessing?.distance
                                ?.sourceAddressLatLng.lng
                            }
                          />
                        )}
                      {state.sbrDetail?.postProcessing?.distance
                        ?.sourceAddressLatLng &&
                        state.sbrDetail?.postProcessing?.distance
                          ?.destinationAddressLatLng && (
                          <StartEndMarker
                            lat={
                              state.sbrDetail?.postProcessing?.distance
                                ?.destinationAddressLatLng.lat
                            }
                            lng={
                              state.sbrDetail?.postProcessing?.distance
                                ?.destinationAddressLatLng.lng
                            }
                          />
                        )}
                    </GoogleMapReact>
                  </div>
                </Grid.Column>

                <Grid.Column width={6}>
                  <div className="detail-section">
                    <h1>Seller Details:</h1>
                    <p>
                      <span className="label">Name:</span>
                      <span>{state.sellerDetail.sellerName}</span>
                    </p>
                    <p>
                      <span className="label">Service Radius:</span>
                      <span>{state.sellerDetail.serviceRadius + " mi"}</span>
                    </p>
                  </div>

                  {havePostProcessing() || state.sbrDetail.quickInfo ? (
                    <div className="detail-section">
                      <>
                        <h1>Request Details:</h1>

                        {state.sbrDetail.postProcessing.distance ? (
                          <DisplayDistanceNew
                            hidePricing={true}
                            sbr={{
                              postProcessing: state.sbrDetail.postProcessing,
                              singleBuyerRequestID: state.requestID,
                            }}
                            isDistanchShow={() => {}}
                            refreshMap={() => {}}
                          ></DisplayDistanceNew>
                        ) : (
                          ""
                        )}
                        {state.sbrDetail.postProcessing.serviceLocation ? (
                          <>
                            <DisplayHomeAddress
                              sbr={{
                                postProcessing: state.sbrDetail.postProcessing,
                                singleBuyerRequestID: state.requestID,
                              }}
                              refreshMap={() => {}}
                            ></DisplayHomeAddress>
                          </>
                        ) : (
                          ""
                        )}
                        {state.sbrDetail.quickInfo &&
                        state.sbrDetail.quickInfo.length > 0 ? (
                          <div className="quick-info">
                            <p>
                              <span className="label">Quick Info:</span>
                              <span>{state.sbrDetail.quickInfo}</span>
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid.Column>
              </>
            ) : (
              ""
            )}
          </Grid.Row>
        </Grid>
      </Segment>
    </Container>
  );
};

export default RadiusCheckContainer;
